/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * TAF Delivery API
 * OpenAPI spec version: 1.0
 */

export type AccommodationBookingsPageContentModelContentType = typeof AccommodationBookingsPageContentModelContentType[keyof typeof AccommodationBookingsPageContentModelContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccommodationBookingsPageContentModelContentType = {
  accommodationBookingsPage: 'accommodationBookingsPage',
} as const;
